export default Object.freeze({
    completed: 'completed',
    skipped: 'skipped',
})
